import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Button, Form, InputGroup, FormControl, Spinner } from 'react-bootstrap'
import { BsPersonFill, BsEye, BsEyeSlash } from 'react-icons/bs';
import "assets/css/Auth/loginForgot.css"
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import logo from "../../assets/img/Logo.png"
import { toast } from "react-toastify";
import { loginAction } from "../../Redux/Auth/actions";
import {useNavigate} from "react-router-dom";


export default function Login() {
    const user = useSelector(state => state.authReducer.data)
    const loginError = useSelector(state => state.authReducer.loginError)
    const userRole = useSelector((state) => state.authReducer?.data?.role);

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const [showSpinner, setSpinner] = useState(false);
    const [loggedIn, setLoggedIn] = useState(userRole)
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const toastConfig = {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
    };

    useEffect(() => {
        if(loggedIn){
            navigate(`/${userRole}/inbound`, { replace: true });
        }

    }, [loggedIn]);
    const handleClickLogin = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            toast.error("Please fill all the fields", toastConfig);
        } else {
            setSpinner(true)
            const body = {
                email: email,
                password: password
            }
            const result = await loginAction(dispatch, body);
            if (result.success) {
                setSpinner(false)
                setLoggedIn(true)
                // const role = localStorage.getItem("role");
                // const userRole = role
                //     ? new TextDecoder().decode(
                //         new Uint8Array(role.split(",").map(Number)).buffer
                //     )
                //     : null;
                // console.log("USER ROLE IN LOGIN PAGE", userRole)
                // navigate(`/${userRole}/inbound`, { replace: true });
            } else  {
               setSpinner(false)
            }
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    return (
        <Container fluid>
            <Row className='vh-100'>
                <Col md={7} sm={5} className='d-none d-md-block custom-bg'></Col>
                <Col className='d-flex flex-column justify-content-center align-items-center'>
                    <img src={logo} alt='logo' width={320} />
                    <div className='custom-spacer'></div>
                    <div className='text-center w-50'>
                        <Form noValidate validated={validated} onSubmit={handleClickLogin}>
                            <Form.Group className="mb-3" controlId="formPlaintextEmail">

                                <InputGroup className="custom-border-input shadow">
                                    <FormControl type="email" placeholder="Email" name="email" className="custom-border" onChange={(e) => setEmail(e.target.value)} required style={{ border: "none" }}
                                    />
                                    <InputGroup.Text className="custom-border-icons">
                                        <BsPersonFill />
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formPlaintextPassword">
                                <InputGroup className="custom-border-input shadow" >
                                    <FormControl
                                        type={passwordVisible ? 'text' : 'password'}
                                        placeholder="Pasword"
                                        name='password'
                                        onChange={(e) => setPassword(e.target.value)}
                                        className='custom-border'
                                        required
                                        style={{ border: "none" }}
                                    />

                                    <InputGroup.Text className="custom-border-icons">
                                        {passwordVisible ? (
                                            <BsEyeSlash onClick={togglePasswordVisibility} />
                                        ) : (
                                            <BsEye onClick={togglePasswordVisibility} />
                                        )}
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                            <div className='d-flex flex-column'>
                                <Link to="/forgotpassword" className='text-right custom-text'>Forgot Password?</Link>
                                {!showSpinner ? <Button variant=" p-2 custom-button" type='submit'>Login</Button> :
                                    <Button variant=" p-2 custom-button" disabled>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" variant='light' className='mr-2' />
                                        Loading...
                                    </Button>}
                            </div>
                        </Form>
                    </div>
                    {/* <p>{accountID}</p> */}
                    <Row className='d-flex align-items-center'>
                        <Col><hr className='custom-line' /></Col>
                        <Col className='custom-para'>Or</Col>
                        <Col><hr className='custom-line' /></Col>
                    </Row>
                    <Button variant=" w-50 p-2  custom-button"><img src='https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-09-512.png' width={20} alt='google' />Login With Google</Button>
                </Col>
            </Row>
        </Container>
    )
}

